import { Link } from "react-router-dom";
import { getFeaturedArticles } from "@/mocks/articles";

export default function ArticlesSection() {
  const featuredArticles = getFeaturedArticles();

  return (
    <section className="w-full py-20 md:py-28 bg-white">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-end justify-between mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              精选文章
            </h2>
            <p className="text-foreground-500 max-w-xl leading-relaxed">
              由 mogu 官方团队精心撰写，帮助你深入了解 mogu 的核心功能与最佳实践
            </p>
          </div>
          <Link
            to="/category/tutorial"
            className="hidden sm:flex items-center gap-1.5 text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group rounded-2xl border border-foreground-100 bg-white overflow-hidden hover:border-foreground-300 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  title={`${article.title} - mogu`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-background-100 text-foreground-600 whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{article.readTime} 分钟阅读</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-foreground-700 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-4">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{article.date}</span>
                  <span className="text-xs font-medium text-foreground-700 flex items-center gap-1">
                    阅读全文
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/tutorial"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}